import React from "react";
import {
    Grid,
    Box,
    Card,
    CardContent,
    Container,
    Typography,
    CardHeader,
} from "@mui/material";

import ZendeskWidget from "./ZendeskWidget";
import SupportContactDetails from "./SupportContactDetails";
import Banner from "../Common/Banner/Banner";
import BreadcrumbBuilder from "../Common/Breadcrumbs/BreadcrumbBuilder";

// static constants that do not depend on dynamic data should be created outside of component
const runtimeConfig = window.__APP_CONFIG__ || {};

const version = process.env.REACT_APP_VERSION;
const environment = process.env.NODE_ENV;
const clientId =
    runtimeConfig.AUTH_SYSTEM_CLIENT_ID ||
    process.env.REACT_APP_AUTH_SYSTEM_CLIENT_ID;
const iam =
    runtimeConfig.AUTH_SYSTEM_URL ||
    process.env.REACT_APP_AUTH_SYSTEM_URL;

// navigator.platform is deprecated; navigator.userAgentData.platform is not widely used yet
// - using a forward compatible version with fallback
const platform =
    (navigator.userAgentData && navigator.userAgentData.platform) ||
    navigator.platform;

function Help() {
    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                <Grid item xs={12}>
                    <Banner
                        image="https://cdn.premierit.com/images/banners/support/bnr-support_001.png"
                        title="Help"
                        body={
                            <Typography variant="body1">
                                Get instant answers to the most common
                                questions.
                            </Typography>
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <SupportContactDetails account="" />
                </Grid>
                <Grid item xs={12}>
                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            title={
                                <Typography component="h2" variant="h2">
                                    About Centric
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Box className="card-content">
                                <dl className="list-data">
                                    <dt>Version</dt>
                                    <dd>{version}</dd>
                                    <dt>Env.</dt>
                                    <dd>{environment}</dd>
                                    <dt>Client</dt>
                                    <dd>{clientId}</dd>
                                    <dt>Auth</dt>
                                    <dd>{iam}</dd>
                                </dl>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            title={
                                <Typography component="h2" variant="h2">
                                    Your web browser
                                </Typography>
                            }
                            subheader={
                                <Typography variant="body1">
                                    If you are requested by a support agent to
                                    provide your web browser details, please use
                                    the information displayed below:
                                </Typography>
                            }
                        ></CardHeader>
                        <CardContent>
                            <Box className="card-content">
                                <dl className="list-data">
                                    <dt>User Agent</dt>
                                    <dd>{navigator.userAgent}</dd>
                                    <dt>Platform</dt>
                                    <dd>{platform}</dd>
                                    <dt>Language</dt>
                                    <dd>{navigator.language}</dd>
                                    <dt>Cookies</dt>
                                    <dd>
                                        {navigator.cookieEnabled
                                            ? "Enabled"
                                            : "No"}
                                    </dd>
                                    <dt>Plugins</dt>
                                    <dd>
                                        {Array.from(navigator.plugins)
                                            .map(({ name }) => name)
                                            .join(", ")}
                                    </dd>
                                </dl>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Card className="card">
                        <Box className="card-content"></Box>
                    </Card>
                </Grid>
            </Grid>
            <ZendeskWidget />
        </Container>
    );
}

export default Help;
